module.exports = __webpack_public_path__ + "img/embedded6.cb2cc0f6.png";